const filterKey = [
  { title: "show all", key: "*" },
  { title: "Trading Bot", key: "trading-bot" },
  { title: "Prediction Bot", key: "prediction-bot" },
  { title: "DeFi", key: "defi" },
  { title: "Analytics", key: "dapp" },
  { title: "DEX", key: "dex" },
  { title: "NFT", key: "nft" },
];

const projectData = [
  {
    type: ["trading-bot", "dex"],
    role: "Solana Sniper Trading Bot | Solana DEX Automation Bot",
    skills: ["Solana", "Rust", "Blockchain", "Crypto Trading Bot", "DEX Trading Bot", "Web3 Development", "Algorithmic Trading"],
    imgUrl: "imgs/works/solana-sniper-bot.gif",
    summary:
      "Detects new token pools and executes trades within milliseconds. Real-time sniping with profit targets and stop-loss automation.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
  {
    type: ["trading-bot"],
    role: "Solana Copy Trading Bot | Wallet Tracking Automation",
    skills: ["Solana", "Crypto Trading Bot", "Blockchain Monitoring", "Web3 Automation", "Node.js", "Algorithmic Trading"],
    imgUrl: "imgs/works/solana-copy-trading-bot.png",
    summary:
      "Tracks profitable wallets and mirrors their trades instantly. Includes risk controls and analytics.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
  {
    type: ["trading-bot", "dex", "defi"],
    role: "Ethereum Arbitrage Bot | DEX Price Arbitrage System",
    skills: ["Ethereum", "Solidity", "Arbitrage Trading", "DeFi", "Web3 Development", "Algorithmic Trading"],
    imgUrl: "imgs/works/eth-arb-bot.png",
    summary:
      "Finds price gaps across DEXs and executes arbitrage trades. Multi-DEX scanning with gas optimization.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
  {
    type: ["trading-bot", "prediction-bot"],
    role: "Polymarket Trading Bot | Prediction Market Automation",
    skills: ["Polymarket", "Crypto Trading Bot", "Algorithmic Trading", "Python", "Blockchain Automation"],
    imgUrl: "imgs/works/poly-prediction.png",
    summary:
      "Automates prediction market trades based on probabilities. Monitors events and executes custom strategies.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
  {
    type: ["trading-bot", "prediction-bot"],
    role: "Kalshi Event Market Bot | Automated Trading System",
    skills: ["Kalshi", "Algorithmic Trading", "Python", "Trading Automation", "Data Analysis"],
    imgUrl: "imgs/works/kalshi-event-bot.png",
    summary:
      "Automates trades on Kalshi event markets. Analyzes odds and executes strategies with risk controls.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
  {
    type: ["defi"],
    role: "Solana Liquidity Monitoring Bot | DeFi Analytics Tool",
    skills: ["Solana", "DeFi", "Blockchain Analytics", "Web3 Monitoring", "Rust"],
    imgUrl: "imgs/works/solana-liquidity-monitoring-bot.png",
    summary:
      "Tracks liquidity pools and whale movements on Solana DEXs. Real-time alerts and analytics.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
  {
    type: ["trading-bot", "dapp"],
    role: "Ethereum MEV Monitoring System | Blockchain Analytics",
    skills: ["Ethereum", "MEV", "Blockchain Analytics", "Web3", "Node.js"],
    imgUrl: "imgs/works/mev-tx-monitoring-system.png",
    summary:
      "Scans the mempool for MEV opportunities. Gas analytics and transaction pattern detection.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
  {
    type: ["dapp"],
    role: "Solana Wallet Analytics Platform",
    skills: ["Solana", "Blockchain Analytics", "Data Analysis", "Web3 Development"],
    imgUrl: "imgs/works/solana-wallet-analytics.gif",
    summary:
      "Analyzes wallet performance and finds profitable traders. Profit tracking and smart money detection.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
  {
    type: ["defi"],
    role: "DeFi Yield Farming Automation Bot",
    skills: ["DeFi", "Yield Farming", "Ethereum", "Smart Contracts", "Solidity"],
    imgUrl: "imgs/works/Defi-yeld-farming-automation.png",
    summary:
      "Auto-allocates liquidity across DeFi protocols to maximize yield.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
  {
    type: ["trading-bot", "dex", "defi"],
    role: "Cross-Chain Arbitrage Bot | Multi-Chain Trading Automation",
    skills: ["Blockchain", "Ethereum", "Arbitrage", "DeFi", "Web3"],
    imgUrl: "imgs/works/cross-chain-arbitrage.png",
    summary:
      "Detects price gaps across Ethereum, BSC, and Arbitrum. Automated cross-chain execution.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
  {
    type: ["trading-bot"],
    role: "Solana Token Launch Scanner | New Token Detection Bot",
    skills: ["Solana", "Blockchain Monitoring", "Rust", "Web3 Development"],
    imgUrl: "imgs/works/token-lunch-monitor.png",
    summary:
      "Detects new token launches and liquidity events in real time. Tracks developer wallets.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
  {
    type: ["trading-bot", "dex"],
    role: "Crypto Trading Strategy Engine",
    skills: ["Algorithmic Trading", "Python", "Crypto Trading Bot", "Data Analysis"],
    imgUrl: "imgs/works/Dex-trading-strategy-engine.png",
    summary:
      "Create and run automated trading strategies. Backtesting and performance analytics.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
  {
    type: ["dapp"],
    role: "Smart Contract Interaction Platform",
    skills: ["Solidity", "Ethereum", "Web3.js", "Smart Contracts"],
    imgUrl: "imgs/works/smart-contract-interaction-toolkit.png",
    summary:
      "Interact with smart contracts and monitor blockchain activity. Event and transaction tracking.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
  {
    type: ["dapp"],
    role: "Blockchain Data Pipeline | On-Chain Analytics Infrastructure",
    skills: ["Blockchain", "Data Engineering", "PostgreSQL", "WebSockets", "Python"],
    imgUrl: "imgs/works/Crypto-market-data-pipeline.png",
    summary:
      "Collects and processes on-chain data. Real-time ingestion with analytics dashboards.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
  {
    type: ["dapp"],
    role: "Crypto Whale Wallet Tracker",
    skills: ["Blockchain Analytics", "Crypto Monitoring", "Web3", "Python"],
    imgUrl: "imgs/works/whale-wallet-tracker.png",
    summary:
      "Monitors large wallets and alerts on major transactions. Whale activity analytics.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
  {
    type: ["nft", "trading-bot"],
    role: "Solana NFT Sniper Bot | Automated NFT Mint Bot",
    skills: ["Solana", "NFT", "Blockchain", "Rust"],
    imgUrl: "imgs/works/NFT-sniper-bot.png",
    summary:
      "Auto-mints NFTs during Solana launch events. Mint monitoring and wallet automation.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
  {
    type: ["dapp"],
    role: "Blockchain Monitoring & Alert System",
    skills: ["Blockchain", "Monitoring Systems", "Web3", "Python"],
    imgUrl: "imgs/works/blockchain-alert-system.png",
    summary:
      "Triggers alerts on specific on-chain events. Transaction, contract, and wallet monitoring.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
  {
    type: ["defi", "trading-bot"],
    role: "Crypto Portfolio Automation Platform",
    skills: ["Crypto Trading", "Portfolio Management", "Python", "Blockchain"],
    imgUrl: "imgs/works/Crypto-Portfolio-Automation-Tool.png",
    summary:
      "Auto-rebalances crypto portfolios by strategy rules. Analytics and allocation tracking.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
  {
    type: ["defi"],
    role: "DeFi Risk Monitoring Dashboard",
    skills: ["DeFi", "Smart Contracts", "Blockchain Analytics", "Solidity"],
    imgUrl: "imgs/works/DeFi-Risk-Monitoring-Platform.png",
    summary:
      "Analyzes DeFi protocol risks and health. Risk scoring and liquidity monitoring.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
  {
    type: ["trading-bot", "dapp"],
    role: "Real-Time Crypto Trading Dashboard",
    skills: ["Crypto Trading", "Data Visualization", "Web3", "Trading Automation"],
    imgUrl: "imgs/works/Real-Time-Crypto-Trading-Dashboard.png",
    summary:
      "Monitor trading bots and markets in real time. Trade analytics and performance metrics.",
    siteUrl: "https://github.com",
    githubUrl: "https://github.com",
  },
];

export { filterKey, projectData };
